import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import InactiveIcon from '@components-clean/core/icons/inactive-icon/inactive-icon';

import './index.scss';

export interface SimpleDragDropItemProps {
    [x: string]: unknown;
    dataItem: DragDropListItemProps;
    selected?: boolean;
    className?: string;
    filteredColumn?: DragDropListItemProps[];
    toDisplayColumn?: boolean;
    inactiveIconTooltip?: string;
}

const SimpleDragDropItem = (props: SimpleDragDropItemProps) => {
    const { dataItem, selected, toDisplayColumn, draggable, className, ...others } = props;

    const ref = useRef<HTMLLIElement>(null);

    const hasSuffixIcons = (dataItem?.active === false && toDisplayColumn) || dataItem?.suffix;

    const isDraggable = !dataItem.disabled && (draggable as boolean);

    // If selected changes, or the item's index changes (which can happen when dragging and dropping),
    // we want to remove focus if the item is not selected.
    // This fixes an issue where the previously selected item, or the item located where the dragged item used to be,
    // retains focus so it looks like it is still selected
    useEffect(() => {
        if (!selected && ref.current) {
            ref.current.blur();
        }
    }, [selected, dataItem.index]);

    return (
        <li
            ref={ref}
            draggable={isDraggable}
            className={cn('simple-drag-drop-item', className, dataItem.disabled && 'disabled')}
            {...others}
        >
            <div className="k-display-flex k-align-items-center k-justify-content-between k-w-full k-h-4.5">
                <div className="trimmed-item-name">
                    <div>
                        {isDraggable && (
                            <FontAwesomeIcon icon={['fas', 'grip-dots-vertical']} className="fa-lg mr-10" />
                        )}
                        <span>{dataItem.title}</span>
                    </div>
                    {hasSuffixIcons && (
                        <span className="k-d-flex k-gap-1 k-align-items-center k-ml-auto">
                            {dataItem?.active === false && toDisplayColumn && (
                                <InactiveIcon
                                    dataTestId="inactive-icon"
                                    className="k-ml-2 k-cursor-help"
                                    tooltipPosition="bottom"
                                />
                            )}
                            {dataItem?.suffix && dataItem.suffix}
                        </span>
                    )}
                </div>
            </div>
        </li>
    );
};

export default SimpleDragDropItem;
